angular.module('zc.projects')

.directive 'zcReviewLinkConfirm', ($filter, BaseProjectConfirm, MongoParticularEvent) ->
  confirm = new BaseProjectConfirm $filter('translate')('projectsSettings.other.reviewLinkConfirm.reviewLink'), ['_id']
  confirm.createDirective (scope, elem, attrs) ->
    MongoParticularEvent.find
      apikey: scope.apikey
      name: 'review_link'
      created_at:
        $gte: moment().subtract(1, 'hour').toDate()
    ,
      limit: 20



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/other/review_link_confirm.directive.coffee